import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env/environment'
import { IChatMessage } from '@app/support-module/core/types'

@Injectable({ providedIn: 'root' })
export class SendSupportMessageCommand {
  constructor(private httpClient: HttpClient) {}

  call(organizationId: number, body: string): Observable<IChatMessage> {
    const url = `${environment.api.app}/help_desk/client/organizations/${organizationId}/messages`
    return this.httpClient.post<IChatMessage>(url, { body })
  }
}
